module.exports = __webpack_public_path__ + "static/img/129.9f669f47.gif";